import application from 'application/application';
import controller from './sync-svg.controller';

import template from './sync-svg.template.html';

application.directive('appSyncSvg', [
	function() {
		return {
			restrict: 'E',
			replace: true,
			scope: {
				size: '@?'
			},
			controller: controller,
			templateUrl: template
		};
	}
]);
